export default __webpack_public_path__ + "static/media/13.0c688566.jpg";